/**
 * WHICH entity types are parties — one console-side statement of a fact the
 * platform declares in SQL and exposes through no registry door.
 *
 * `core.attach_address` raises on anything outside this set in as many words
 * (`'attach_address: % cannot carry addresses'`, core 0031 / 0122), and
 * `core.party_role.party_type` is written with the same two values. So the set
 * is real and it is the database's; what does not exist is a place to ASK for
 * it — there is no `core.is_party(entity)` and no `party` flag on
 * `core.entity_type`.
 *
 * It therefore lives in exactly one file rather than in each surface that needs
 * it. It was in two before this (`routes/EntityDetail.tsx` and the CRM record
 * page's own `entity === 'core_organization'` tests), which is the shape rule 42
 * is about: a fact restated by hand drifts toward whichever copy nobody reads.
 *
 * If a third party kind is ever admitted, the SQL is what changes first and this
 * constant is what has to follow it. That is a gap worth a registry door, not a
 * reason to guess from the key's prefix.
 */
export const PARTY_ENTITIES: ReadonlySet<string> = new Set(['core_person', 'core_organization'])

export const isPartyEntity = (entity: string): boolean => PARTY_ENTITIES.has(entity)
